import type {
  ConditionsField,
  Rules,
  MutationOptions,
  Options,
} from '~/components/BaseForm/types'

type InputSelectSearch = {
  inputType: 'multiselect-search'
  containerInputClass?: string
  conditions?: ConditionsField
  defaultOptions: Options
  hidden?: boolean
  infoText?: MaybeRefOrGetter<string>
  mutationOptions: MutationOptions
  viewModeRow?: boolean
  order?: number
  attr: {
    canClear: boolean
    canDeselect: boolean
    inputHtml?: string
    labelHtml?: string
    labelTextTranslateKey?: string
    minChars: number
    mode?: 'single' | 'multiple' | 'tags'
    name: string
    object?: boolean
    placeholderTranslateKey: string
    resolveOnLoad: boolean
    rules?: Rules
    searchable: true
    trackBy: string
  }
}

const inputSelectSearch: InputSelectSearch = {
  inputType: 'multiselect-search',
  defaultOptions: [],
  mutationOptions: () =>
    Promise.resolve([
      { label: 'Example 1', value: 'exemple-1' },
      { label: 'Example 2', value: 'exemple-2' },
    ]),
  attr: {
    canClear: false,
    canDeselect: false,
    minChars: 1,
    name: 'select-search',
    placeholderTranslateKey: 'global.placeholders.search',
    resolveOnLoad: false,
    searchable: true,
    trackBy: 'label',
  },
}

export default inputSelectSearch
